var tab = new Swiper('.swiperContent', {
   slidesPerView: 1,
   autoHeight: true,
   navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
   },
        
   thumbs: {
     swiper: {
     el: '.swiperTabs',
     slidesPerView: 1,
   }
  },
});

var menu = new Swiper('.swiperMenu', {
  slidesPerView: 1.3,
  spaceBetween: 20,
  freeMode: true,
});
